import { Outlet, ScrollRestoration } from 'react-router';
import SiteHeader from './SiteHeader.jsx';
import SiteFooter from './SiteFooter.jsx';
import useSmoothScroll from '../../hooks/useSmoothScroll.js';

/**
 * Storefront shell. The paper grain lives here rather than on <body> so the
 * admin panel can opt out of it while keeping the same type and colour.
 */
export default function StorefrontLayout() {
  useSmoothScroll();

  return (
    <div className="bg-paper text-ink flex min-h-dvh flex-col overflow-x-clip">
      <a
        href="#main"
        className="label bg-ink text-paper sr-only px-4 py-2 focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50"
      >
        Skip to content
      </a>

      <SiteHeader />

      <main id="main" className="flex-1">
        <Outlet />
      </main>

      <SiteFooter />
      <ScrollRestoration />
    </div>
  );
}
